import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { color } from "../Utils/Constant";
import { FaEye } from "react-icons/fa";
import { IoShareSocial } from "react-icons/io5";
// import { ShareDetailsData } from "../Data/ContactData";
import { fetchUserData } from "../Utils/api";
import WhatsApp from "../Assets/Contact_icons/whatsapp.png";
import sms from "../Assets/Contact_icons/sms.png";
import email from "../Assets/Contact_icons/email.png";
import facebook from "../Assets/Contact_icons/facebook.png";
import instagram from "../Assets/Contact_icons/instagram.png";
import VCardGenerator from "./VCardGenerator";

// stylings
const MainContainer = styled.div`
  padding: 10px 10px 0 10px;
`;
const LogoAndViewsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
`;
const CompanyLogo = styled.img`
  height: 100px;
  width: 340px;
  object-fit: contain;
  margin-top: -10px;
  /* background-color: red; */
  @media (max-width: 768px) {
    width: 250px;
  }
`;
const ViewsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  border: solid 1px ${color.gray};
  padding: 5px;
  border-radius: 5px;
  /* width: 27%; */
`;
const ViewsText = styled.p`
  font-size: 12px;
  font-weight: 600;
  color: ${color.gray};
`;
const ProfilePicAndIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-evenly;
  gap: 10px;
  margin-top: -15px;
`;
const ProfileImage = styled.img`
  width: 155px;
  height: 155px;
  border-radius: 50%;
  object-fit: cover;
  background-color: ${color.light_gray};
`;

const StyledIcon = styled.div`
  color: ${(props) => (props.active ? color.primary : color.white)};
  font-size: 25px;
  width: 38px;
  height: 38px;
  background-color: ${(props) => (props.active ? color.white : color.blue)};
  border-radius: 50%;
  padding: 5px;
  object-fit: contain;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  transition: color 0.3s ease;
  &:hover {
    background-color: ${color.white};
    color: ${color.primary};
  }
`;
const MainProfileContentContainer = styled.div`
  background-color: ${color.white};
  padding: 10px;
  border-radius: 10px;
`;
const ProfileDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 25px;
`;
const Name = styled.p`
  font-size: 18px;
  font-weight: 600;
`;
const Designation = styled.p`
  font-size: 14px;
  color: ${color.gray};
`;
const CompanyName = styled.p`
  font-size: 14px;
`;
const ShareModal = styled.div`
  position: absolute;
  top: 50px;
  right: 0;
  background: white;
  border: 1px solid ${color.light_gray};
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 200px;
`;

const ShareOption = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  cursor: pointer;
  border-radius: 5px;
  transition: background 0.3s;

  &:hover {
    background: ${color.v_light_gray};
  }
`;

const ShareIcon = styled.img`
  width: 20px;
  height: 20px;
`;
const ShareIconText = styled.p`
  font-size: 14px;
  color: ${color.gray};
`;

const Header = ({ userName }) => {
  const [data, setDate] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalVisisble, setModalVisible] = useState(false);
  const [views, setViews] = useState(0);
  // const [base64Image, setBase64Image] = useState("");
  // const [loadingImage, setLoadingImage] = useState(true);
  const modalRef = useRef(null);
  const cardLink = "https://nfcadmin.mediastreambh.com/";

  useEffect(() => {
    // fetching data functionality
    const getData = async () => {
      try {
        const result = await fetchUserData(userName);
        setDate(result[0]);
      } catch (err) {
        // console.log("error fetching data in header", err);
      } finally {
        setLoading(false);
      }
    };
    getData();

    // modal closing functionality
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setModalVisible(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);

    // views fetching
    const storedViews = localStorage.getItem("cardView");
    const newViews = storedViews ? parseInt(storedViews) + 1 : 1;
    localStorage.setItem("cardView", newViews);
    setViews(newViews);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [userName]);

  if (loading)
    return <p style={{ textAlign: "center", padding: "10px" }}>Loading...</p>;

  return (
    <MainContainer>
      {/* company logo and views section */}
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <ViewsContainer>
          <FaEye color={color.gray} />
          {/* <ViewsText>Views: {views}</ViewsText> */}
          <ViewsText>Views: 43871</ViewsText>
        </ViewsContainer>
      </div>
      <LogoAndViewsContainer>
        <CompanyLogo
          src={`https://nfcadmin.mediastreambh.com/public/${data.logo}`}
          alt="Company logo"
        />
      </LogoAndViewsContainer>
      {/* profile image and icons section */}
      <MainProfileContentContainer>
        <ProfilePicAndIconContainer>
          {/* save contact icon */}
          <VCardGenerator />
          {/*<StyledIcon as={HiUserAdd} onClick={downloadVCard} />*/}
          {/* profile image */}
          <ProfileImage
            src={`https://nfcadmin.mediastreambh.com/public/${data.profile_image}`}
          />
          {/* share icon */}
          <div style={{ position: "relative" }} ref={modalRef}>
            <StyledIcon
              active={isModalVisisble}
              as={IoShareSocial}
              onClick={() => setModalVisible(!isModalVisisble)}
            />
            {isModalVisisble && (
              <ShareModal>
                {/* whatsapp */}
                <ShareOption
                  onClick={() =>
                    window.open(
                      `https://wa.me/?text=${encodeURIComponent(cardLink)}`,
                      "_blank"
                    )
                  }
                >
                  <ShareIcon src={WhatsApp} />
                  <ShareIconText>Share via WhatsApp</ShareIconText>
                </ShareOption>
                {/* sms */}
                <ShareOption
                  onClick={() =>
                    window.open(
                      `sms:?body=${encodeURIComponent(cardLink)},"_blank"`
                    )
                  }
                >
                  <ShareIcon src={sms} />
                  <ShareIconText>Share via SMS</ShareIconText>
                </ShareOption>
                {/* email */}
                <ShareOption
                  onClick={() =>
                    window.open(
                      `mailto:?subject=Check this card&body=${encodeURIComponent(
                        cardLink
                      )}`,
                      "_blank"
                    )
                  }
                >
                  <ShareIcon src={email} />
                  <ShareIconText>Share via Email</ShareIconText>
                </ShareOption>
                {/* facebook */}
                <ShareOption
                  onClick={() =>
                    window.open(
                      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                        cardLink
                      )}`,
                      "_blank"
                    )
                  }
                >
                  <ShareIcon src={facebook} />
                  <ShareIconText>Share via Facebook</ShareIconText>
                </ShareOption>
                {/* instagram */}
                <ShareOption
                  onClick={() =>
                    window.open(
                      `https://www.instagram.com/accounts/login/?source=logged_out_sem`,
                      "_blank"
                    )
                  }
                >
                  <ShareIcon src={instagram} />
                  <ShareIconText>Share via Instagram</ShareIconText>
                </ShareOption>
              </ShareModal>
            )}
          </div>
        </ProfilePicAndIconContainer>
        {/* profile description section */}
        <ProfileDetailsContainer>
          <Name>{data.name}</Name>
          <Designation>{data.roll}</Designation>
          <CompanyName>{data.designation}</CompanyName>
        </ProfileDetailsContainer>
      </MainProfileContentContainer>
    </MainContainer>
  );
};

export default Header;
